import {ACTIVATE_LOADER, DEACTIVATE_LOADER, RESET_NAVIGATION_TO_HOME, SET_ACTIVE_MENU } from "../../actions/app.type";

const initialState = {
    active_menu:"home",
    current_screen:"Home",
    show_loader:true,
    theme:"",
};

export default (state = initialState, action:{type:string,payload:object,}) => {
    switch (action.type) {
   
    case ACTIVATE_LOADER:
        return {
            ...state,
            show_loader:true,
        };
    case DEACTIVATE_LOADER:
        return {
            ...state,
            show_loader:false,
        };
    case RESET_NAVIGATION_TO_HOME:
        return {
            ...state,
            active_menu:"home",
            current_screen:"Home",
        };
    case SET_ACTIVE_MENU:
        return {
            ...state,
            active_menu: (action.payload as any),
        };
    default:
        return state;
    }
};
